import {
    Divider,
    HStack,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useMediaQuery,
} from '@chakra-ui/react'
import clsx from 'clsx'
import { ReactNode } from 'react'

interface Props {
    title?: string
    body: ReactNode | string
    footer?: ReactNode | string
    isOpen: boolean
    onClose: () => void
    size?: string
    isHeaderVisible?: boolean | undefined
    isFooterVisible?: boolean | undefined
    toBottom?: boolean
    showOverlay?: boolean
    showFrom?: 'scale' | 'none' | 'slideInBottom' | 'slideInTop'
    isCentered?: boolean
    classNameBody?: string
    scrollBehavior?: 'inside' | 'outside'
}

const baseClass = 'CustomModal'

export const CustomModal = ({
    title,
    body,
    footer,
    isOpen,
    onClose,
    size,
    isHeaderVisible = true,
    isFooterVisible = true,
    toBottom = false,
    showOverlay = true,
    showFrom = 'scale',
    isCentered = false,
    classNameBody = '',
    scrollBehavior = 'inside',
}: Props): JSX.Element => {
    const [isDesktop] = useMediaQuery('(min-width: 1230px)', {
        fallback: false,
    })

    return (
        <Modal
            className={baseClass}
            isOpen={isOpen}
            // scrollBehavior={isDesktop ? 'outside' : 'inside'}
            scrollBehavior={scrollBehavior}
            onClose={onClose}
            size={size}
            // @ts-ignore
            motionPreset={showFrom}
            isCentered={true}
            autoFocus={false}
            // blockScrollOnMount={false}
        >
            <ModalOverlay hidden={!showOverlay} className={`${baseClass}__overlay`} />
            <ModalContent
                className={`${baseClass}__content`}
                alignSelf={toBottom ? 'flex-end' : 'center'}
                marginBottom={toBottom ? 0 : 'auto'}
                position={'relative'}
                maxH="96vh"
                display="flex"
                flexDirection="column"
            >
                {isHeaderVisible && (
                    <>
                        <ModalHeader
                            position="sticky"
                            top={0}
                            zIndex={1}
                            bg="white"
                            borderTopLeftRadius={'8px'}
                            borderTopRightRadius={'8px'}
                            className={`${baseClass}__header`}
                        >
                            <HStack>
                                <Text flex={1}>{title}</Text>
                                <ModalCloseButton top={4} />
                            </HStack>
                        </ModalHeader>

                        <Divider />
                    </>
                )}

                <ModalBody
                    className={clsx(`${baseClass}__body`, classNameBody)}
                    p={0}
                    border={toBottom ? '1px solid #e0e0e0' : 'none'}
                    boxShadow={toBottom ? '0px -8px 40px 0px rgba(0, 0, 0, 0.08)' : 'none'}
                    flex="1"
                    overflowY="auto"
                    overscrollBehavior={'contain'}
                >
                    {body}
                </ModalBody>

                {isFooterVisible && footer && (
                    <>
                        <Divider />
                        <ModalFooter
                            className={`${baseClass}__footer`}
                            p={4}
                            display="flex"
                            justifyContent="flex-end"
                            position="sticky"
                            bottom={0}
                            zIndex={1}
                            bg="white"
                            borderBottomLeftRadius={'8px'}
                            borderBottomRightRadius={'8px'}
                        >
                            {footer}
                        </ModalFooter>
                    </>
                )}
            </ModalContent>
        </Modal>
    )
}
